import React from 'react'
import { Icon } from 'antd'
import { FULCRUM_FORM_LABELS } from '../../constants/fulcrumForms'
import './FulcrumLoadProgress.css'

const STATUS_META = {
  pending: {
    icon: 'clock-circle',
    label: 'Waiting',
    className: 'fulcrum-load-progress__status--pending',
  },
  loading: {
    icon: 'loading',
    label: 'Loading',
    className: 'fulcrum-load-progress__status--loading',
  },
  done: {
    icon: 'check-circle',
    label: 'Ready',
    className: 'fulcrum-load-progress__status--done',
  },
  error: {
    icon: 'close-circle',
    label: 'Failed',
    className: 'fulcrum-load-progress__status--error',
  },
}

const FulcrumLoadProgress = ({ datasets, progress, title = 'Loading page data', summary, overlay = false }) => {
  const doneCount = datasets.filter((key) => progress[key] === 'done').length
  const loadingKey = datasets.find((key) => progress[key] === 'loading')
  const defaultSummary =
    doneCount === datasets.length
      ? 'Complete'
      : `${doneCount} of ${datasets.length} complete${
          loadingKey ? ` · ${FULCRUM_FORM_LABELS[loadingKey] || loadingKey} in progress` : ''
        }`

  const content = (
    <div className={`fulcrum-load-progress${overlay ? ' fulcrum-load-progress--card' : ''}`}>
      <h2 className="fulcrum-load-progress__title">{title}</h2>
      <p className="fulcrum-load-progress__summary">{summary || defaultSummary}</p>
      <ul className="fulcrum-load-progress__list">
        {datasets.map((key) => {
          const status = progress[key] || 'pending'
          const meta = STATUS_META[status]
          const label = FULCRUM_FORM_LABELS[key] || key

          return (
            <li key={key} className={`fulcrum-load-progress__item ${meta.className}`}>
              <Icon type={meta.icon} spin={status === 'loading'} className="fulcrum-load-progress__icon" />
              <span className="fulcrum-load-progress__label">{label}</span>
              <span className="fulcrum-load-progress__status">{meta.label}</span>
            </li>
          )
        })}
      </ul>
    </div>
  )

  if (overlay) {
    return <div className="fulcrum-load-progress__overlay">{content}</div>
  }

  return content
}

export default FulcrumLoadProgress
